"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIME_TYPES = void 0;
/**
 * MIME types for file exports
 */
exports.MIME_TYPES = {
    XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
